import React, { Component } from "react";
import Auth from "core/services/authToken";

export default class IdleWatch extends Component {
  static defaultProps = {
    events: ["mousemove", "mousedown", "keydown", "touchstart", "scroll"],
    timeout: 60 * 60 * 1000,
  };

  constructor(props) {
    super(props);
    // Bind once so attachEvents/removeEvents pass the *same* function reference to
    // addEventListener/removeEventListener. Previously each method called
    // `this.handleEvent.bind(this)` independently, which creates a new function every time —
    // removeEventListener silently no-ops on a reference it never added, so listeners were
    // never actually removed on unmount (a real leak, not an enzyme/RTL artifact).
    this.handleEvent = this.handleEvent.bind(this);
  }

  componentDidMount() {
    if (Auth.checkTokens()) {
      this.attachEvents();
      this.setTimeout();
    }
  }

  componentDidUpdate(prevProps) {
    if (!this.timeout && Auth.checkTokens()) {
      this.attachEvents();
      this.setTimeout();
    }
  }

  componentWillUnmount() {
    this.removeEvents();
    clearTimeout(this.timeout);
  }

  setTimeout() {
    const self = this;
    this.timeout = setTimeout(() => {
      self.props.onIdle();
      clearTimeout(self.timeout);
    }, this.props.timeout);
  }

  attachEvents() {
    this.props.events.forEach((e) => {
      window.addEventListener(e, this.handleEvent, true);
    });
  }

  removeEvents() {
    this.props.events.forEach((e) => {
      window.removeEventListener(e, this.handleEvent, true);
    });
  }

  handleEvent() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    if (Auth.checkTokens()) {
      this.setTimeout();
    }
  }

  render() {
    return null;
  }
}
